import React from 'react';
import { Row } from 'react-table';

import { formatNumberCompact } from '@trqk/utils';

import { footerHeight, COLUMN_IDS } from '../../constants';

interface IncludeChannelFooterProps {
    rows: Row<TrqkGapChannel>[];
}

/**
 * Sums and displays the number of cells where `cell.value.include === true` for the
 * `IncludeChannelCell`s.
 * @param props - {@link IncludeChannelFooterProps}
 */
export function IncludeChannelFooter({
    rows,
}: IncludeChannelFooterProps): JSX.Element {
    const totalIncludedChannels = rows.reduce(
        (acc: number, row: Row<TrqkGapChannel>): number => {
            const checked =
                row?.values?.[COLUMN_IDS.INCLUDE_CHANNEL]?.checked ?? false;

            if (checked) {
                return acc + 1;
            }

            return acc;
        },
        0,
    );

    return (
        <div className="flex items-center" style={{ height: footerHeight }}>
            <p className="pl-2">{formatNumberCompact(totalIncludedChannels)}</p>
        </div>
    );
}
